import { AuthContext, AuthContextType } from '@/providers/authProvider';
import { useContext } from 'react';

export const useAuth = (): AuthContextType => {
  return useContext(AuthContext) as AuthContextType;
};
